import React, { useState, useEffect } from 'react';
import { Button, Modal, Grid } from '@material-ui/core';
import { CORP_BLUE } from 'config/config';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';

const defaultReclamo = {
  num: '',
  fechaIngreso: '',
  tipo: '',
  reclamante: '',
  Rut: '',
  Etapa: '',
  materia: '',
  via: '',
  region: '',
  comuna: '',
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  minHeight: 350,
  minWidth: 350,
  bgcolor: 'background.paper',
  backgroundColor: 'white',
  borderRadius: 5,
  boxShadow: 24,
  fontFamily: 'Roboto',
};

const headerStyle = {
  backgroundColor: CORP_BLUE,
  color: 'white',
  textAlign: 'center',
  fontFamily: 'Roboto',
};
const btnCancelStyle = { paddingBottom: 20 };
const btnAceptarStyle = { paddingRight: 10, paddingBottom: 20 };

const AddRecurso = ({ openDialog = false, close, reclamo = defaultReclamo }) => {
  const getUploadParams = ({ meta }) => {
    return { url: 'https://httpbin.org/post' };
  };

  // called every time a file's `status` changes
  const handleChangeStatus = ({ meta, file }, status) => {};

  // receives array of files that are done uploading when submit button is clicked
  /*   const handleSubmit = (files, allFiles) => {
 
    allFiles.forEach(f => f.remove());
  }; */

  const [num, setNum] = useState('');
  /* const [file, setFile] = useState(null); */

  useEffect(() => {
    if (reclamo) {
      setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo');
    }
  }, [reclamo]);

  const onCloseDialog = event => {
    /*   setFile(null); */
    close();
  };

  return (
    <Modal open={openDialog} onClose={onCloseDialog}>
      <Grid container alignItems="stretch" style={modalStyle}>
        <Grid container item alignItems="center" style={headerStyle}>
          <Grid item xs={12}>
            <h2>Añadir Antecedente a Reclamo N° {num}</h2>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div style={{ width: '100%', overflow: 'hidden' }}>
            <Dropzone
              styles={{ dropzone: { overflow: 'hidden' } }}
              getUploadParams={getUploadParams}
              onChangeStatus={handleChangeStatus}
              /*   onSubmit={handleSubmit} */
              inputWithFilesContent={'Subir mas'}
              inputContent="Arrastre archivos o haga click aquí"
            />
          </div>
        </Grid>
        <Grid container item justifyContent="flex-end" alignItems="flex-end" xs={12} spacing={2}>
          <Grid item style={btnCancelStyle}>
            <Button onClick={onCloseDialog}>Cancelar</Button>
          </Grid>
          <Grid item style={btnAceptarStyle}>
            <Button color="primary" variant="contained" onClick={() => {}}>
              &nbsp;Subir&nbsp;
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AddRecurso;
